ep.common = ep.common || {};

(function (ep) {
    "use strict";

    ep.common.lingvoUtility = {
        /*
         **  generates plural form of number given
         **  formString has the following format: number of plural form is followed by strings required by this form. Items are separated with #.
         **  number of strings depend on the form. {0} term in the string is replaced with value given
         **  https://developer.mozilla.org/en/Localization_and_Plurals for reference
         *
         * Examples of formString :
         *        1#{0} person#{0} people
         *        7#{0} человек#{0} человека#{0} людей
         */
        plural: function (value, formString, replaceValue) {

            var data = formString.split("#");

            var result = "PLURAL-UNDEFINED";

            switch (data[0]) {
                case "1":
                    // Plural rule #1 (2 forms)
                    // Families: Germanic (Danish, Dutch, English, Faroese, Frisian, German, Norwegian, Swedish), Finno-Ugric (Estonian, Finnish, Hungarian), Language isolate (Basque), Latin/Greek (Greek), Semitic (Hebrew), Romanic (Italian, Portuguese, Spanish, Catalan)
                    // is 1: 1
                    // everything else: 0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, …
                    if (value === 1) {
                        result = data[1];
                    }
                    else {
                        result = data[2];
                    }
                    break;
                case "2":
                    //Families: Romanic (French, Brazilian Portuguese)
                    //is 0 or 1: 0, 1
                    //everything else: 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, …
                    if (value === 0 || value === 1) {
                        result = data[1];
                    }
                    else {
                        result = data[2];
                    }
                    break;
                case "7":
                    // Plural rule #7 (3 forms)
                    // Families: Slavic (Croatian, Serbian, Russian, Ukrainian)

                    // there are three forms:
                    // ends in 1, but not in 11 - 1, 21,31 ...
                    // ends in 2, 3, 4 but not in 12, 13, 14 - 22, 23, 24, 32, 33, 34, 42, 43, 44 ...
                    // everything else
                    // and decimal - second form in russian
                    if ((value % 10) === 1 && value % 100 !== 11) {
                        result = data[1];
                    }
                    else if (( (value % 10 >= 2 && value % 10 <= 4) && (value % 100 != 11 && value % 100 != 12 && value % 100 != 13 && value % 100 != 14) ) || (value % 1 !== 0)) {
                        result = data[2];
                    }
                    else {
                        result = data[3];
                    }
                    break;

                case "7p":
                    if ((value % 10) === 1 && value !== 11) {
                        result = data[1];
                    }
                    else {
                        result = data[2];
                    }
                    break;

                case "9":
                    //Plural rule #9 (3 forms)
                    //Families: Slavic (Polish)
                    //is 1: 1
                    //ends in 2-4, excluding 12-14: 2, 3, 4, 22, 23, 24, 32, 33, 34, 42, 43, 44, 52, 53, 54, 62, 63, 64, 72, 73, 74, 82, 83, 84, 92, 93, 94, 102, 103, 104, 122, 123, 124, 132, 133, 134, 142, 143, 144, 152, 153, 154, 162, 163, 164, 172, 173, 174, 182, 183, …
                    //everything else: 0, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 25, 26, 27, 28, 29, 30, 31, 35, 36, 37, 38, 39, 40, 41, 45, 46, 47, 48, 49, 50, 51, 55, 56, 57, 58, 59, 60, 61, 65, 66, 67, 68,
                    if (value === 1) {
                        result = data[1];
                    }
                    else if ((value % 10 >= 2 && value % 10 <= 4) &&
                        (value !== 11 && value !== 12 && value !== 13 && value !== 14)) {
                        result = data[2];
                    }
                    else {
                        result = data[3];
                    }
                    break;
            }

            return result.replace("{0}", replaceValue || value);

        },


        formatAsOrdinalNum: function (num) {
            var func = ep.currentCultureSettings.getOrdinalNumSuffix;
            return num + (func ? func(num) : "");
        }
    };
})(ep);

export const lingvoUtility = ep.common.lingvoUtility;